/**
 * created by lei lei on 2020/6/2
 * 待我处理的列表
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Col, Modal, notification, Table} from "antd";
import {connect} from "react-redux";
import {myMessageGridData, myReviewGridData, postPublic} from "../../../../actions";
import {applicationName, formatDate, uuid} from "../../../../utils";
import {MaterialModel} from "../../../../containers/weiChatPublish";
import EditWeiBo from "../../../../components/weibo/editWeiBo";

 class ActivityPendingAllComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {
            myAuditdatas: [],
            needTodoCount:[],
            downloadSourceNumber:[],
            jumpToDownloadSource:[],
            editModalVisible: false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        let that = this;
       /* var timeUpdate=setInterval(function () {*/
            if(that.props.currentUser){
               // clearInterval(timeUpdate)
                let param = that.props.currentUser;

                myReviewGridData(param, that.updateMyReviewGrid.bind(that));
            }

      /*  },400)*/
    }
    updateMyReviewGrid(myAuditdata) {
        let number = 0;
        if(myAuditdata.data && myAuditdata.data.length > 0){
            for(let i = 0;i < myAuditdata.data.length;i++){
                if(myAuditdata.data[i].actButton.deploymentkey === "downloadSource"){
                    number +=1;
                }
            }
        }
        this.setState({
            myAuditdatas: myAuditdata.data,
            needTodoCount:myAuditdata.data?myAuditdata.data.length:0,
            myAuditloading: true,
            downloadSourceNumber:number
        })
    }

    render() {

        const myAuditcolumns = [{
            title: '标题',
            dataIndex: 'object.content',
            key: 'object.content',
            width: '60%',
            ellipsis:true,
            render: (text, record) => {

                return <span style={{cusor:'pointer'}} onClick={() => this.chekcData(record)}>{this.getTitle(record)}</span>
            }
        },
            {
                title: '提交人',
                dataIndex: '_userName',
                key: '_userName',
                width: '15%',
                align: 'center',
                ellipsis:true,
                render: (text, record) => {
                    return this.getUserName(record)
                }
            },
            {
                title: '提交时间',
                dataIndex: 'createTime',
                key: 'createTime',
                width: '15%',
                align: 'center',
                ellipsis:true,
                render: (text, record) => {
                    return this.getCreateDate(record)
                }

            }, {
                title: '操作',
                dataIndex: 'operate',
                key: '操作',
                width: '10%',
                align: 'center',
                ellipsis:true,
                render: (text, record) =>
                    <a style={{cusor:'pointer'}} onClick={() => this.chekcData(record)}><u>查看</u></a>,

            }];

        return (
            <div>
                <div  className='mydeskContain'>
                    <MaterialModel visible={this.state.editModalVisible} title={this.weChatParams.title} mediaCode={this.weChatParams.mediaCode} materialId={this.weChatParams.materialId}/>
                    <Modal key={uuid()}
                           title={"编辑微博"}
                           visible={this.state.editWeiboVisible}
                           onCancel={this.closeWeibo.bind(this)}
                           bodyStyle={{height:"570px"}}
                           width={860}
                           footer={null}
                           keyboard={false}
                           maskClosable={false}
                    >
                        <EditWeiBo refreshList={()=>{}} currentMedia={this.eidtWeiboMediaCode} weiboId={this.eidtWeiboId} />
                    </Modal>
                    <div className='mydesk-cardtitle'>
                        <span>待我处理</span>
                        <span>{this.state.needTodoCount}条</span>
                        {  this.state.downloadSourceNumber > 0 ? <div style={{float:"right",marginRight:20,color:"blue"}}  onClick={this.jumpToDownloadSource}>(您有{this.state.downloadSourceNumber}条资源申请待处理)</div> : "" }
                    </div>
                    <Table locale={{emptyText: '暂无数据'}} size={'small'}  scroll={this.state.myAuditdatas.length>8?{y:320}:{}}  rowKey={'id'}  pagination={false} rowClassName={() => 'editable-row'}
                           dataSource={this.state.myAuditdatas} columns={myAuditcolumns}/>
                </div>
            </div>
        )
    }

     //关闭微博弹窗
     closeWeibo = () => {
         this.setState({
             editWeiboVisible: false,
         });
     };

     /**
      * 获取标题
      * @param recorde
      */
     getTitle(recorde) {
         let obj = recorde.object;
         let title = "";
         let li;
         if (recorde.actButton.deploymentkey.indexOf("story") === 0 || recorde.actButton.deploymentkey === "yuegao"
             || recorde.actButton.deploymentkey === "fzr" || recorde.actButton.deploymentkey === "unfzr" || recorde.actButton.deploymentkey === "activityStory") {
             if(recorde.actButton.deploymentkey === "fzr" || recorde.actButton.deploymentkey === "unfzr"){
                 title = "(采访任务稿件)" + obj.title;
             }else{
                 title = obj.title;
             }
             li=<i className='icon icon-pc'></i>
         } else if (recorde.actButton.deploymentkey === "weixin") {
             if(obj.stuffList && obj.stuffList[0]){
                 title = obj.stuffList[0].title;
             }
             li=<i className='icon icon-wechat'></i>
         } else if (recorde.actButton.deploymentkey === "weibo") {
             title = obj.content;
             li=<i className='icon icon-wb'></i>
         } else if (recorde.actButton.deploymentkey === "downloadSource") {
             title = recorde.object.userName + "-" + recorde.object.deptName +"-" + window.formatDate(recorde.object.createTime).substring(0,10) + "-资源下载申请";
             li=<i className='icon icon-downloadSource'></i>
         } else if (recorde.actButton.deploymentkey === "douyin"){
             title = obj.title;
             li=<i className='icon icon-dy'></i>
         }
         return <span className={""} style={{cursor:"pointer"}} title={title}>{li}{title}</span>
     }

     /**
      * 获取作者信息
      * @param recorde
      */
     getUserName(recorde) {
         let obj = recorde.object;
         let author = obj._userName;
         return author;
     }

     /**
      *获取提交时间
      * @param recorde
      */
     getCreateDate(recorde) {
         let obj = recorde.object;
         let submitDate = formatDate(obj._updateDate);
         return submitDate
     }
     //查看按钮，不同的流程，不同的媒体弹不同的框
     chekcData(record) {
         let obj = record.object;
         if (record.actButton.deploymentkey.indexOf( "story") == 0 || record.actButton.deploymentkey.indexOf("yuegao") == 0 || record.actButton.deploymentkey.indexOf("activityStory") == 0) {
             if (obj.mediaCode || record.actButton.deploymentkey.indexOf( "story") == 0 || record.actButton.deploymentkey.indexOf("activityStory") == 0) {
                 this.websiteViewStory(record);
             } else { //投稿端
                 this.viewStory(record);
             }
         }else if (record.actButton.deploymentkey.indexOf( "fzr") == 0  || record.actButton.deploymentkey.indexOf( "unfzr") == 0) {
             this.showInterview(record);
         } else if (record.actButton.deploymentkey.indexOf( "weixin") == 0) {
             this.weixinViewMaterial(record);
         } else if (record.actButton.deploymentkey.indexOf( "weibo") == 0 ) {
             this.websiteViewWeibo(record);
         } else if (record.actButton.deploymentkey.indexOf( "downloadSource") == 0 ) {
             this.downloadSourceView(record);
         } else if (record.actButton.deploymentkey.indexOf("douyin") ==0 ){
             this.douyinViewMaterial(record);
         }
     }
     /**
      * 稿件的查看  （管理端）
      * @param record
      */
     websiteViewStory(record) {
         let that = this;

         let width=parseInt(window.document.body.clientWidth * 0.9);
         let height=parseInt(window.document.body.clientHeight * 0.9);
         let synColumns = record.object.news;
         let mainColumnInfo = synColumns.filter(item=>item.mainColumn==1)[0];

         let treeContentId = 0;
         let mediaCode = "";
         if(mainColumnInfo){
             //window.layer.alert("主栏目信息获取错误，无法打开该文章");
             if(mainColumnInfo.treeContentId){
                 treeContentId = mainColumnInfo.treeContentId;
             }
             if(mainColumnInfo.mediaCode){
                 mediaCode = mainColumnInfo.mediaCode;
             }
         }
         let interviewId = record.interviewId || 0;
         window.openFull("/cm-sites/pms/addContribute/addContributeNews.html?interviewId=" + interviewId+ "&eiditStoryId=" + record.object._serviceId+"&processInstanceId="+record.object._ProcessInstanceId+"&treeContentId="+treeContentId+"&currentMediaCode="+mediaCode
             + "&actButtonId="+record.actButton.id,record.title,null,{area:[width+'px',height+'px']},null,function(){
             myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
         });

     }
     /**
      * 稿件的查看 （投稿端）
      * @param record
      */
     viewStory(record) {
         let that = this;
         var data = record;
         var object = data.object;

         let width=parseInt(window.document.body.clientWidth * 0.9);
         let height=parseInt(window.document.body.clientHeight * 0.9);

         window.openFull("/cm-sites/pms/writing/writingNew.html?eiditStoryId=" + object._serviceId
             + "&processInstanceId=" + object._ProcessInstanceId + "&actButtonId=2",record.title,null,{area:[width+'px',height+'px']},null,function() {
             myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
         });
     }
     /**
      *稿件的查看  unfzr 的查看
      * @param record
      */
     showInterview(record){
         let that = this;
         let interviewId= record.object.interviewId;
         let width=parseInt(window.document.body.clientWidth * 0.9);
         let height=parseInt(window.document.body.clientHeight * 0.9);
         // window.location.hash = '#/interviewTask/interviewTaskdetail/'+interviewId;
         window.openFull("/cm-sites/pms/interviewTask/interviewTaskdetail.html?interviewId="+interviewId,record.title,null,{area:[width+'px',height+'px']},null,function() {
             myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
         });
     }

     // 微信参数
     weChatParams = {
         title : "编辑素材",
         materialId : 0,
         mediaCode : ""
     };

     /**
      * 微信的查看功能
      */
     weixinViewMaterial(record){
         // let data = record;
         // let object = data.object;
         // let dialogHeight = parseInt(window.$(window).height()) - 100;
         // let maxHeight = 815;
         // dialogHeight = dialogHeight>maxHeight?maxHeight:dialogHeight;//这样做的目的是搜索框那里刚好只显示两个块儿
         // let url = "#/wechat/edit/"+ object._serviceId +"/" + object.mediaCode;
         // window.openFull(url, "编辑素材", null, {
         //     area: ['1070px', dialogHeight + 'px'],
         //     shade: 0.5,
         //     zIndex: 19991015,
         //     resize: false
         // });
         this.weChatParams = {
             title : "编辑素材",
             materialId : record.object.id,
             mediaCode : record.object.mediaCode
         };
         this.setState({
             editModalVisible : true
         })
     }

     lastLoginLog(){
         let that = this;
         let newLogin = window.getCookie("newLogin");
         if(newLogin === true || newLogin === 'true'){
             postPublic("/cm-sites-" + applicationName() + "/getLastLoginLog",null,function(res){
                 window.delCookie("newLogin","/",window.location.host);
                 if(res){
                     let description = <div>
                         <span>上次登陆时间：{window.formatDate(res.loginTime)}</span>
                         <span>上次登陆ip：{res.ip}</span>
                     </div>;
                     that.openNotification(description);
                 }
             } )
         }
     }

     openNotification(description){
         notification.info({
             message: '上次登陆时间',
             description: description,
             placement: 'bottomRight'
         });
     }

     eidtWeiboMediaCode;
     eidtWeiboId;

     /**
      * 微博查看功能
      * @param record
      */
     websiteViewWeibo(record){
         this.eidtWeiboMediaCode = record.object.mediaCode;
         this.eidtWeiboId = record.object.id;
         this.setState({
             editWeiboVisible:true
         })
     }

     /**
      * 资源下载申请
      * @param record
      */
     downloadSourceView(record){
         let that = this;
         window.layer.open({
             title: '资源下载审核',
             type: 2,
             content: '/cm-sites/'+ applicationName() +'/downloadApplication/downloadApplication.html?actButtonId=8&id=' + record.object.id,
             area: [parseInt(document.body.clientWidth *  0.76) + 'px',parseInt(document.body.clientHeight * 0.8) + 'px'],
             success: function (layero, index) {
                 var iframeWin = window[layero.find('iframe')[0]['name']];
             },end: function(){
                 myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
             }
         });
     }

     /**
      * 抖音的查看功能
      */
     douyinViewMaterial(record){
         let that = this;
         let data = record;
         let object = data.object;
         let url = "/cm-sites/pms/douyin/publish.html?currentMedia="+object.mediaCode+"&id="+object.id+"&actButtonId=20";
         window.openFull(url,"抖音",null,null,null,function() {
             myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
         });
     }

}
function mapStateToProps(state){
    return {
        currentUser: state.systemReducer.currentUser,
    }
}
export default connect(mapStateToProps)(ActivityPendingAllComponents);